/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { put, call } from 'redux-saga/effects';

import { FETCH_CONFLICTS } from 'src/redux/pull-request/actions';
import { getPullRequestApis } from 'src/sagas/helpers';

export function* fetchConflictsSaga(
  owner: string,
  slug: string,
  id: string | number
) {
  try {
    const api = yield* getPullRequestApis();
    // @ts-ignore
    const conflicts = yield call(api.getConflicts, owner, slug, id);
    yield put({
      type: FETCH_CONFLICTS.SUCCESS,
      payload: conflicts,
    });
  } catch {
    // We aren't concerned with this request erroring for now
  }
}
